export * from './auth.guard';


// WEBPACK FOOTER //
// ./src/app/guard/index.ts